/**
 * WizardV2 Page - Full-screen Sidebar Wizard (v2)
 * 
 * This is the new wizard with sidebar layout.
 * The original /wizard route remains untouched as a fallback.
 */

import React from 'react';
import { WizardV2 } from '../components/wizard/v2';

export default function WizardV2Page() {
  return <WizardV2 />;
}
